<template>
  <div id="meet-body" ref="personFileElement">
    <BlockFrame :header="{title:appletData.name,icon:appletData.icon,more:true,code:'wdhy_hybm_dhz',nomessage:nomessage}">
      <div v-if="listData.length>0">
        <div v-for="(item,index) in listData" :key="index" class="link-message" @click="cellClick(item)">
          <div class="item">
            <div class="title" style="display:flex;">
              <div style="width:96%;">{{ item.flSubject }}</div>
              <div style="color:#ec8423;">{{ item.exportStatus }}</div>
            </div>
            <div class="bottom">
              <span class="name">
                <span style="margin-right:25px;"><span v-if="item.flCreator" v-text-lbl="'hygl.portlet.convener'"> 召集人：</span>{{ item.flCreator }}</span>
                <span>{{ item.meetPlace }}</span>
              </span>
              <span class="time">{{ item.startTime }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="text-align:center;padding-top: 30px;">
        <img src="images/w-imgs/nomessage.png" style="max-width:180px"><br>
        <span v-text-lbl="'common.noData'" style="font-size:15px;color:#dbdbdb"> 暂无数据 </span>
      </div>
    </BlockFrame>
    <my-join ref="myJoinMeeting" />
  </div>
</template>

<script>
export default {
    props: {
        appletData: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            moduleInfo: { 'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/vwMyMeetingJoin/form.html', 'winWidth': 1000, 'delUrl': 'hygl/vwMyMeeting/delete', 'addNewUrl': 'hygl/vwMyMeeting/addNew', 'insertUrl': 'hygl/vwMyMeeting/insert', 'moduleCode': 'vwMyMeeting', 'listAdvSearchExpandPanel': 0, 'winHeight': 600, 'updateUrl': 'hygl/vwMyMeeting/update', 'listDataUrl': 'hygl/vwMyMeeting/listdata', 'getByIdUrl': 'hygl/hyap/getById', 'listAdvSearchAllFields': 0 },
            loginUser: this.$store.getters.loginUser,
            contentWidth: '', // 浏览器窗口宽度
            pageTotal: 0,
            checkType: '',
            listData: [],
            searchType: 0, // 首页默认文件夹
            params: {},
            listDataUrl: '',
            dialogTableVisible: false,
            nomessage: false
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.getListData()
        this.$options.components['BlockFrame'] = this.$loadComponent('@/wapp/common/components/BlockFrame/index')
        this.$options.components['myJoin'] = this.$loadComponent('@/wapp/hygl/components/wdhy/HyglWdhyMyJoin')
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onresize, false)
        this.$bus.off('refreshTableData', this.refreshTableData)
        this.$bus.$off('clicklog')
    },
    mounted() {
        window.addEventListener('resize', this.onresize, false)
        this.$bus.on('refreshTableData', this.refreshTableData)
    },
    methods: {
        onresize() {
            this.contentWidth = this.$refs.personFileElement.offsetWidth
        },
        refreshTableData() {
            this.getListData(this.checkType)
        },
        async getListData(index) {
            this.checkType = index
            // 获取dom元素宽度
            this.$nextTick(function() {
                this.contentWidth = this.$refs.personFileElement.offsetWidth
            })
            // this.listDataUrl = '/znbg/task/listdata?urlsearch=myType:1;status:0;isExecutor:0'
            var param = {
                pageSize: 5,
                pageNum: 1,
                listpageViewUrl: 'hygl.vwMyMeetingMyJoin.list.vue'
            }
            // 是否开启伪数据
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                const list = await this.$getDefaultData(this, this.appletData.id)
                this.listData = list.splice(0, 5)
                // this.nullProcessing('value', this.appletData.icon, this.position)
                return
            }
            this.$http({
                method: 'post',
                url: '/hygl/vwMyMeeting/listdata',
                params: param
            }).then(res => {
                if (res.code === 'success') {
                    this.listData = res.body.pageInfo.list

                    if (res.body.pageInfo.list.length === 0) {
                        this.nomessage = true
                    }
                    this.pageTotal = res.body.pageInfo.total
                    const length = this.listData.length
                    if (length < 5 && length > 0) {
                        for (let i = 0; i < 5 - length; i++) {
                            this.listData.push({})
                        }
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        cellClick(row) {
            // this.$bus.$emit('clicklog', row)
            if (row.id) {
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    this.$bus.emit('openDefaultDialog', this.appletData.name)
                    return
                }
                this.moduleInfo.addNew = false
                window.open('#/newBusiForm?voId=' + row.id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(this.moduleInfo)) + '&title=' + encodeURIComponent('会议管理') + '&busiInfo=' + encodeURIComponent('会议信息') + '&formUrl=hygl.plan.form_newLook&innerUrl=&noEdit=true')
            }
        },
        // 打开表单
        openBusiForm(row, canEdit) {
            //	this.moduleInfo.formTemplate='#/dcontent/vuebusiform/W/znbg.task.mainForm.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent('#/dcontent/vuebusiform/W/znbg.task.mainForm.vue?sysCode=' + this.$route.meta.sysCode)
            this.formTitle = '会议详情1'
            this.moduleInfo.showFile = true
            this.moduleInfo.personName = this.$store.state.user.loginUser.personName
            this.isUpdate = 1
            console.log('this.$store.state.user', this.$store.state.user)
            if (this.$store.state.user.loginUser.personName === row.createName || row.taskExecutorName.indexOf(this.$store.state.user.loginUser.personName) > -1) {
                this.busiformBtns = null
            } else {
                this.busiformBtns = [
                    {
                        id: 'btn_close',
                        btnName: '关 闭',
                        btnIcon: 'close',
                        btnClick: 'closeDialog',
                        btnPermission: '',
                        btnType: ''
                    }
                ]
            }
            var that = this
            this.$nextTick(function() {
                that.$bus.emit('openBusiform', that.moduleInfo, row, canEdit)
                // that.$forceUpdate()
            })
        }
    }
}
</script>

<style scoped lang="scss">
#meet-body{
    height: 100% !important;
}
//    /deep/ .el-table .el-table__header-wrapper .el-table__header thead th{
//         // font-size: 14px;
//         background-color: #fff;
//         //border: none;
//     }
//     /deep/ .el-table__body-wrapper{
//         cursor: pointer;
//     }
//     // /deep/ .el-table td, .el-table th.is-leaf{
//     //     border: none;
//     // }
//     /deep/.el-table::before {
//         height: 0px;
//         width: 0;
//     }
//    /deep/ .el-table .cell{
//         white-space: nowrap;
//         text-overflow: ellipsis;
//         overflow: hidden;
//     }
// }
//     /deep/ .el-table__body{
//         height:225px;
//     }

/deep/ .has-gutter tr th{
        background-color: #fff !important;
     }
/deep/ .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    //    border-bottom: 1px solid #EBEEF5!important;
    border-bottom:none !important;
}
/deep/.el-table .el-table__header-wrapper .el-table__header thead th{
    border-bottom-color: #fff;
}
/deep/.block-box .block-content-border .el-table.el-table--border td {
    border-right-color: #fff;
}
/deep/[data-v-8aeac2f6] .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf[data-v-8aeac2f6] {
    // border-bottom: 1px solid #EBEEF5 !important;
    border-bottom:none !important;
    height: 60px;
}

   .link-message{
  list-style: none;
    .item{
        padding: 10px 15px;
        width:100%;
        height: 100%;
        border-bottom: 1px dashed #EFF4FC;
        cursor: pointer;
    }
     .title{
                font-size: 14px;
                color: #333333;
                height: 25px;
                line-height: 25px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .bottom{
                font-size: 13px;
                color: #9B9B9B;
                height: 25px;
                line-height: 25px;
                font-family: MicrosoftYaHei;
                display: flex;
                justify-content: space-between;
                .name{
                    display: inline-block;
                    font-size: 13px;
                    font-family: MicrosoftYaHei;
                    color: #999;
                }
                .time{
                    display: block;
                    width: 120px;
                    float:left;
                    font-size: 12px;
                    color: #999;
                    text-align: right;
                }
  }
}
.link-message:last-child .item {
  border-bottom: none;
}
</style>
